import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { QuestionStyled } from "./styled";
import { IMG_PATH } from "utils/constants/imgPath";
import { Displays, Icons } from "components";

const Question = ({ theme_standard, src, title, description }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <QuestionStyled className={customClass}>
      <div className="figture_img">
        <Displays.ImageSmooth
          src={
            src ? IMG_PATH + src : "/assets/images/mockups/activity-news.jpg"
          }
          aspectRatio="1 / 1"
        />
      </div>
      <div className="activity_news_detail">
        <div className="activity_news_title_bar">
          <div className="activity_news_title">{title}</div>
          <button className="arrow_button">
            <Icons.ArrowRightCircle2 color="#434343" />
          </button>
        </div>
        <div className="activity_news_subtitle">{description}</div>
      </div>
    </QuestionStyled>
  );
};

Question.propTypes = {};

export default Question;
